import { createContext, useState, useEffect } from "react";
import { getProductData } from "./productsStore";
import { toHaveFocus } from "@testing-library/jest-dom/matchers";

export const CartContext = createContext({
    items: [],
    getProductQuantity: () => { },
    addOneToCart: () => { },
    removeOneFromCart: () => { },
    deleteFromCart: () => { },
    getTotalCost: () => { },
    updateItemRating: () => { },
    setEmail: () => { },
    setorderNumber: () => { },
    setconfirmationNumber: () => { }
});

export function CartProvider({ children }) {
    const [cartProducts, setCartProducts] = useState(() => {
        // Load cart from localStorage when component mounts
        const savedCart = localStorage.getItem("cart");
        return savedCart ? JSON.parse(savedCart) : [];
    });

    const [email, setEmail] = useState("");
    const [orderNumber, setorderNumber] = useState('');
    const [confirmationNumber, setconfirmationNumber] = useState('');

    // Save cartProducts to localStorage whenever it changes
    useEffect(() => {
        localStorage.setItem("cart", JSON.stringify(cartProducts));
    }, [cartProducts]);

    function getProductQuantity(id) {
        const quantity = cartProducts.find(product => product.id === id)?.quantity;
        
        if (quantity === undefined) {
            return 0;
        }

        return quantity;
    }
function updateQuantity(id, newQty) {
    if (newQty <= 0) {
        deleteFromCart(id);
        return;
    }

    setCartProducts(prev =>
        prev.map(product =>
            product.id === id
                ? { ...product, quantity: newQty }
                : product
        )
    );
}

    function addOneToCart(id, price,size,color,style,image,thumImage,thumId,image2,rating, weight,imagePrice,colorName4API,SalePrice,imageSize1,imageSize2,imageSize3,imageSize4,uploadedImageUrl) {
        const quantity = getProductQuantity(id);
        // const price = getProductData(cartProducts,id);
        // console.log("id:",id, price,size,color,style,"image:",image,"thumImage:",thumImage,thumId,"image2:",image2,"rating:",rating)


        if (quantity === 0) { // product is not in cart
            setCartProducts(
                [
                    ...cartProducts,
                    {
                        id: id,
                        quantity: 1,
                        price: price,
                        size: size,
                        color: color,
                        style: style,
                        image: image,
                        thumImage: thumImage,
                        thumId: thumId,
                        image2: image2,
                        rating: rating,
                        weight: weight,
                        imagePrice: imagePrice,
                        garmentPrice: parseFloat(price-imagePrice).toFixed(2),
                        colorName4API: colorName4API,
                        SalePrice:SalePrice,
                        imageSize1:imageSize1,
                         imageSize2:imageSize2,
                          imageSize3:imageSize3,
                           imageSize4:imageSize4,
                           uploadedImageUrl:uploadedImageUrl
                  
             
                    }
                ]
            )
        } 
        else { 
           
            setCartProducts(
                cartProducts.map(
                    product =>
                    product.id === id                                
                    ? { ...product, quantity: product.quantity + 1 } 
                    : product                                        
                )
            )
        }
        // pishnehade gpt
//          else {
//   setCartProducts(
//     cartProducts.map(product =>
//       product.id === id
//         ? {
//             ...product,
//             quantity: product.quantity + 1,
//             price,
//             size,
//             color,
//             style,
//             image,
//             thumImage,
//             thumId,
//             image2,
//             rating,
//             weight,
//             imagePrice,
//             garmentPrice: parseFloat(price - imagePrice).toFixed(2),
//             colorName4API,
//             SalePrice,
//             imageSize1,
//             imageSize2,
//             imageSize3,
//             imageSize4
//           }
//         : product
//     )
//   );
// }

       
    }

    function removeOneFromCart(id) {
        const quantity = getProductQuantity(id);

        if(quantity === 1) {
            deleteFromCart(id);
        } else {
            setCartProducts(
                cartProducts.map(
                    product =>
                    product.id === id                                // if condition
                    ? { ...product, quantity: product.quantity - 1 } // if statement is true
                    : product                                        // if statement is false
                )
            )
        }
    }


    function deleteFromCart(id) {
        // [] if an object meets a condition, add the object to array
        // [product1, product2, product3]
        // [product1, product3]
        setCartProducts(
            cartProducts =>
            cartProducts.filter(currentProduct => {
                return currentProduct.id !== id;
            })  
        )
    }

    function getTotalCost() {
        let totalCost = 0;
        cartProducts.map((cartItem) => {
            const productData = getProductData(cartProducts,cartItem.id);
            totalCost += (productData.price * cartItem.quantity);
        });
        return totalCost;
    }
   
       // New function to update an item's rating
    function updateItemRating(id, newRating) {
        setCartProducts(cartProducts.map(product =>
            product.id === id ? { ...product, rating: newRating } : product
        ));
    }

    const contextValue = {
        items: cartProducts,
        email:email,
        orderNumber:orderNumber,
        confirmationNumber:confirmationNumber,
        setorderNumber,
        setconfirmationNumber,
        setEmail ,
        getProductQuantity,
        addOneToCart,
        removeOneFromCart,
        deleteFromCart,
        getTotalCost,
        setCartProducts,
        updateItemRating ,
         updateQuantity, 
        }
// console.log(contextValue)
    return (
        <CartContext.Provider value={contextValue}>
            {children}
        </CartContext.Provider>
    );
}

export default CartProvider;
